import React from "react";
import { Image } from "react-bootstrap";
import NotF from "../../images/page-not-found-g806f85362_1280.png";
const NotFound = () => {
  return (
    <div className="container text-center" style={{ height: "100vh" }}>
      <h1 className="text-white bg-dark p-5">404 Not Found</h1>
    </div>
  );
};

export default NotFound;
